import { UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class NameValidator {
    public static alreadyExists(registeredNames: string[]): ValidatorFn {
        return (formControl: UntypedFormControl): ValidationErrors | null => {
            if (registeredNames && registeredNames.length > 0 && formControl.value != null) {
                const newName = formControl.value.toLowerCase();
                return registeredNames.find((name) => name.toLowerCase() === newName) ? { alreadyExists: true } : null;
            }

            return null;
        };
    }
}
